module.exports = __webpack_public_path__ + "img/bg-camera-tablet-pr-vector.01934b0c.svg";